/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ScheduledJobStatusEnum = 'FAILED' | 'SUCCESS' | 'NONE' | 'PENDING_FIRST_RUN' | 'RUNNING';

export const ScheduledJobStatusEnum = {

    FAILED: 'FAILED' as ScheduledJobStatusEnum,

    SUCCESS: 'SUCCESS' as ScheduledJobStatusEnum,

    NONE: 'NONE' as ScheduledJobStatusEnum,

    PENDING_FIRST_RUN: 'PENDING_FIRST_RUN' as ScheduledJobStatusEnum,

    RUNNING: 'RUNNING' as ScheduledJobStatusEnum
};

